'use client';

import React from 'react';
import RestrictedListingContext, {} from '../../../contexts/RestrictedListingContext';
import ExploreSetsTable, { IExploreSetsProps } from './ExploreSetsTable';
import DataroomTwoFactorAuthenticationContext from '@dataroom/authentication/DataroomTwoFactorAuthenticationContext';

interface IProps extends IExploreSetsProps {
  isPublicRequest: boolean,
}
export default (props: IProps) => (
  <DataroomTwoFactorAuthenticationContext>
    <RestrictedListingContext isPublicRequest={ props.isPublicRequest ?? false }>
      <ExploreSetsTable { ...props } />
    </RestrictedListingContext>
  </DataroomTwoFactorAuthenticationContext>
);
